<template>
  <div class="">
    <el-row :gutter="20">
      <el-col :span="6">
        <div>
          <el-input
            v-model="key"
            placeholder="请输入关键字或词"
            class="input-with-select"
            size="small"
            suffix-icon="el-icon-search"
          />
        </div>
      </el-col>
      <el-col :span="18" class="btn">
        <el-button
          size="small"
          type="primary"
          @click="exportFile"
          v-permission="['操作轨迹下载']"
          >下载</el-button
        >
      </el-col>
    </el-row>
    <div class="container-table">
      <el-table
        ref="multipleSelection"
        stripe
        size="mini"
        :data="operData"
        style="width: 100%"
        :v-loading="loading"
        :header-cell-style="tableHeaderColor"
        border
        :cell-style="cellStyle"
      >
        <el-table-column prop="modules" label="操作模块" width="160" />
        <el-table-column prop="style" label="操作类型" width="100" />
        <el-table-column prop="create_time" label="操作时间" width="180" />
        <el-table-column prop="create_user_name" label="操作者" width="100" />
        <el-table-column prop="ip" label="客户端IP" width="180" />
        <el-table-column prop="detail" label="详情" />
      </el-table>
    </div>
    <!--分页-->
    <div class="pages">
      <el-pagination
        samll
        background
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { getProjectId } from "@/utils/auth";
import { operationList, exportFile } from "@/api/homePage";
import { Alert } from "element-ui";

export default {
  name: "Operation",
  data() {
    return {
      cellStyle: {
        textAlign: "center",
      },
      currentPage: 1,
      pageSize: 10,
      total: null,
      operData: [],
      proId: "",
      loading: false,
      key: "",
      timer: "",
      userDetail: JSON.parse(sessionStorage.getItem("iwrs_user")),
    };
  },
  created() {
    this.proId = getProjectId();
    this.getOperationList();
  },
  watch: {
    key(value) {
      if (this.timer !== null) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.getOperationList, 500);
    },
  },
  methods: {
    exportFile() {
      const baseUrl =
      (sessionStorage.getItem("iwrs_environment") === "PROD"?'/api2':'/api')+
        "/v1.0/iwrs/operation_track/export?project_id=" +
        this.proId +
        "&user_id=" +
        this.userDetail.id +
        "&cjsdlkjcd";
      window.open(baseUrl, "_self");
    },
    getOperationList(reset) {
      const params = {
        project_id: this.proId,
        key: this.key,
        page: reset ? 0 : this.currentPage - 1,
        page_size: this.pageSize,
      };
      operationList(params)
        .then((res) => {
          if (res && res.code === 0) {
            if (res.data && res.data.length > 0) {
              reset ? (this.currentPage = 0) : null;
              this.operData = res.data;
              this.total = res.total;
            } else {
              this.operData = [];
            }
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    // 每页条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getOperationList();
    },
    // 当前页数
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getOperationList();
    },
    // 修改表头颜色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      // 改表头颜色
      if (rowIndex === 0) {
        return "background-color: #D6E4FF;color: #595959;text-align:center;";
      }
    },
  },
};
</script>

<style scoped>
.btn {
  text-align: right;
}
.container-table {
  margin-top: 20px;
}
.title {
  padding: 15px 0;
  background-color: #d6e4ff;
  color: #595959;
  font-weight: 500;
  font-size: 16px;
}
.proInfo {
  background-color: #f0f5ff;
  padding: 20px 30px;
}
.row {
  margin: 20px 0;
  font-size: 14px;
  color: #595959;
}
.left {
  line-height: 26px;
  text-align: right;
}
.pages {
  margin-top: 30px;
  text-align: right;
}
.edit {
  font-size: 12px;
  margin-right: 10px;
}
</style>
<style>
.el-dialog__header {
  padding: 0px;
}
.container-table {
  border: 1px solid #e5eeff;
}
.el-tooltip__popper.is-light {
  border: none;
  background: #ffffff;
  box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08),
    -1px -1px 12px 0px rgba(0, 0, 0, 0.12);
}
.popper__arrow {
  border: none !important;
}

.btn-custom-cancel {
  float: right;
  margin-left: 10px;
}
.el-table__column-filter-trigger i {
  color: #000;
  font-size: 14px;
}
.diaBg {
  background-color: #f0f5ff;
  padding: 20px;
}
</style>
